<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script setup>
import {
  computed,
  onMounted,
  onUnmounted,
} from 'vue';

import { io } from 'socket.io-client';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import {
  applyScheme,
  getSavedScheme,
  getSystemScheme,
  initSystemSchemeListener,
} from '@/utils/colorSchemeUtils.js';

import defaultLayout from './layouts/default.vue';
import guestLayout from './layouts/guest.vue';

const logOut = (payload) => store.dispatch('logOut', payload);
const addAuthStatus = (status) => store.dispatch("addAuthStatus", status);
const getReportPost = (id) => store.dispatch("fetchReportBotId", id);
const userdata = JSON.parse(localStorage.getItem("user"));
const isUserAuth = computed(() => store.getters.getAuthStatus);
const route = useRoute();
const store = useStore();
const layout = computed(() => {
  const layout = route.meta.layout;
  return layout === "default" ? defaultLayout : guestLayout;
});
let unregisterSystemSchemeListener;

const useSocketIO = () => {
  const socket = io('/');
  socket.on("post_marked_bot", (payload) => {
    getReportPost(payload.postId)
  });
  socket.on("new_notification", async () => {
    const { count } = await store.dispatch("fetchNotifications");
    store.dispatch("addNotificationsCount", count);
    //store.dispatch("fetchUnreadNotifications");
    //store.dispatch("updateNotifications", newNotifications);
  });
}

onMounted(async () => {
  try {
    await store.dispatch('getMe');
    // const response = await fetch(`/api/users/me`, {
    //   method: 'GET',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // });

    // if (response.status === 401 || response.status === 403) {
    //   addAuthStatus(false);
    //   if (route.name === 'home') {
    //     await addAuthStatus(false);
    //     logOut(response.status);
    //   }
    // } else {
    //   let user = await response.json();
    //   localStorage.setItem("user", JSON.stringify(user));
    //   store.dispatch('getMe', user.id);
    // }
    applyScheme(getSavedScheme() || getSystemScheme());
    unregisterSystemSchemeListener = initSystemSchemeListener();
  } catch (error) {
    console.warn(error);
  }

  if (userdata) {
    store.dispatch('startGlobalTimer');
    store.dispatch('fetchReputationCategories');
    store.dispatch('fetchUnreadNotificationsCount');
    useSocketIO();

  }
});

onUnmounted(() => {
  if (unregisterSystemSchemeListener) {
    unregisterSystemSchemeListener();
  }
});
</script>
